import React, {useState, useEffect} from 'react';
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates_bus";
import moment from 'moment';
import DataTable from 'react-data-table-component';
import { data } from 'jquery';

export default function PopUpTable({show, handleClose, apiprops, selectedDepo,startDateOfCurrentWeek,endDateOfCurrentWeek,startDateOfPreviousWeek,endDateOfPreviousWeek}) {


    const formattedCurrentStartDate = moment(startDateOfCurrentWeek).format('DD-MMM-YYYY');
    const formattedCurrentEndDate = moment(endDateOfCurrentWeek).format('DD-MMM-YYYY');
    const formattedPreviousStartDate = moment(startDateOfPreviousWeek).format('DD-MMM-YYYY');
    const formattedPreviousEndDate = moment(endDateOfPreviousWeek).format('DD-MMM-YYYY');

    const formattedPreviousEndDate1 = moment(endDateOfPreviousWeek).format('YYYY-MM-DD');
    const formattedPreviousStartDate1 = moment(startDateOfPreviousWeek).format('YYYY-MM-DD');
    const formattedCurrentStartDate1 = moment(startDateOfCurrentWeek).format('YYYY-MM-DD');
    const formattedCurrentEndDate1 = moment(endDateOfCurrentWeek).format('YYYY-MM-DD');

    const { isLoading, error, sendReq: fetchData } = useHttp();

    const [currentmonthWiseData, setCurrentMonthWiseData] = useState([]);
    const [previousmonthWiseData, setPreviousMonthWiseData] = useState([]);
    const [fiveVin, setFiveVin] = useState([]);

    const [dataFetched, setDataFetched] = useState(false);


    useEffect(() => {
      setPreviousMonthWiseData([])
      setCurrentMonthWiseData([])
      if(selectedDepo !== undefined){
        fetchData(
        {
          url: API_URL_MAIN + "trend_analysis_drive_bus/getdepoWiseRange",
          body: { filterdata: {
            // "CITY" : apiprops.city,
            "CITY" : [],
            "DEPO": [selectedDepo],
            "LOB": [],
            "PL": [],
            "PPL": [],
            "SOC": 0,
            "VIN_NUM": [],
            // "endDate": endDateOfCurrentWeek,
            "endDate": formattedPreviousEndDate1,
            "pageSelected": 1,
            // "startDate": startDateOfCurrentWeek,
            "startDate": formattedPreviousStartDate1,
            "AIR_VENTILATION": "",
        }},
        },
        responceMonthWiseData
        );
      }
  }, [selectedDepo]);


  let uniqueVin = [];

  const responceMonthWiseData = (data) =>{

      setCurrentMonthWiseData(data);
      data.forEach(item => {
        uniqueVin.push(item.key.vehicleId);
    });
    setFiveVin(uniqueVin)
  }

  useEffect(() => {
    if(selectedDepo !== undefined){
      fetchData(
      {
        url: API_URL_MAIN + "trend_analysis_drive_bus/getdepoWiseRange",
        body: { filterdata: {
          // "CITY" : apiprops.city,
          "CITY" : [],
          "DEPO": [selectedDepo],
          "LOB": [],
          "PL": [],
          "PPL": [],
          "SOC": 0,
          "VIN_NUM": fiveVin,
          // "endDate": endDateOfPreviousWeek,
          "endDate": formattedCurrentEndDate1,
          "pageSelected": 1,
          // "startDate": startDateOfPreviousWeek,
          "startDate": formattedCurrentStartDate1,
          "AIR_VENTILATION": "",
      }},
      },
      responcepreviousMonthWiseData
      );
    }
    }, [fiveVin]);

    let previousuniqueVin = [];

    const responcepreviousMonthWiseData = (data) =>{
        setPreviousMonthWiseData(data)
        setDataFetched(true);
    }

    const previousMonthSelector = (row) => {
      const previousMonthData = previousmonthWiseData.find(item => item.key.vehicleId === row.key.vehicleId);
      if (previousMonthData && previousMonthData.median_Range) {
        return previousMonthData.median_Range.values["50.0"].toFixed(2);
      }
      return 'NA';
    };

    const columns = [
        {name: 'Vin No.',selector: (row) => row.key.vehicleId,width: '23%',center: true},
        {name: 'Reg No.',selector: (row) => row.key.vehicle_registration_number,width: '17%',center: true},
        {
            // name: `(${formattedCurrentStartDate}) to (${formattedCurrentEndDate})`,
            name:  `(${formattedPreviousStartDate}) to (${formattedPreviousEndDate})`,
            selector: (row) => {
              if (currentmonthWiseData.length > 0) {
                const rowData = currentmonthWiseData.find(item => item.key.vehicleId === row.key.vehicleId);
                if (rowData && rowData.median_Range) {
                  return rowData.median_Range.values["50.0"].toFixed(2);
                }
              }
              return '';
            },
            width: '30%',
            center: true
          },
        {
            // name:  `(${formattedPreviousStartDate}) to (${formattedPreviousEndDate})`,
            name: `(${formattedCurrentStartDate}) to (${formattedCurrentEndDate})`,
            // selector: (row) => {
            //   if (previousmonthWiseData.length > 0) {
            //     const rowData = previousmonthWiseData.find(item => item.key.vehicleId === row.key.vehicleId);
            //     if (rowData && rowData.median_Range) {
            //       return rowData.median_Range.values["50.0"].toFixed(2);
            //     }
            //   }
            //   return '';
            // },
            selector: (row) => previousMonthSelector(row),
            width: '30%',
            center: true
          }
      ];
      

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#83A4CF',
        color: '#fff',
        fontWeight: 'bold'
      },
    },
  };

  return (
    <div style={{width:"500px"}}>
      <div className={`modal ${show ? 'show' : '' }`} tabIndex="-1" role='dialog' style={{ display: show ? 'block' : 'none'}}>
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
              <div className="modal-header">
                  <h5 className="modal-title">Lowest 5 median range buses in the last week</h5>
                  <button type="button" className="close" onClick={handleClose}>
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div className="modal-body">
                      {(dataFetched || previousmonthWiseData.length > 0) && (
                      <DataTable
                        columns={columns}
                        // data={previousmonthWiseData}
                        data={currentmonthWiseData}
                        customStyles={customStyles}
                        fixedHeader={true}
                      />
                    )}
              </div>
          </div>
        </div>
      </div>
    </div>
  )
}
